import { Injectable } from '@angular/core';
import { ComponentBase } from '../component-base';
import { StageService } from './stage.service';
import { SceneUtilsService } from './scene-utils.service';
import { Select3dService } from './select-3d.service';
import { ConstantsService } from './constants.service';
import { MoveCameraService } from '../Component(2D and 3D)/2D/move-camera.service';
import { AppSettingsService } from './app-settings.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { EventLogService, Actions } from './eventLog';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';
import { ProductsService } from './products.service';

declare let THREE: any;

@Injectable()
export class TierStepWidthService extends ComponentBase {

  originalRight: any;
  originalLeft: any;
  oldPosition: any;
  newPosition: any;
  currentSprite: any;
  selectTierSubscription: any;
  changeTierStepSizeAction: Actions.TierStepSizeChangeAction;
  minimalSpaceForStairsOnSIde: number = 0;

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private select3dService: Select3dService,
    private constants: ConstantsService,
    private moveCameraService: MoveCameraService,
    private appSettingsService: AppSettingsService,
    private railingGenerationService: RailingGenerationService,
    private eventLogSrvc: EventLogService,
    private productsService: ProductsService
  ) {
    super();
    this.disable();
  }

  private widthSprites = [];
  private loader = new THREE.TextureLoader();
  private raycaster = new THREE.Raycaster();
  private plane: any;
  private edgesCommonSegmentLength: number;

  private nearestRightPoint: any; // FP
  private nearestLeftpoint: any;  // SP

  drawSprites(): void {
    const currentTier = this.select3dService.getSelectedTier();

    const height = currentTier.getWorldPosition(new THREE.Vector3()).y + 5;
    const cornerPost = this.productsService.getCurrentCornerPost();
    this.minimalSpaceForStairsOnSIde = cornerPost.mountType && cornerPost.mountType.includes('Fascia')? this.constants.minimalSpaceForStairsOnSIde : 0;
    for (let i = 0; i < currentTier.userData.points.length; i++) {
      const count = currentTier.userData.points.length;
      const fPoint = currentTier.userData.points[i];
      const sPoint = currentTier.userData.points[(i + 1) % count];
      const child = currentTier.children.find(obj => obj.name === 'tierSteps');

      if ((
        fPoint.superstructureType === 'tier3StepUp' ||
        fPoint.superstructureType === 'tier2StepUp' ||
        fPoint.superstructureType === 'tier3StepDown' ||
        fPoint.superstructureType === 'tier2StepDown') &&
        fPoint.parent && child) {

        const spriteMap = this.loader.load('../../assets/images/sprites/size_grip_horizontal.png');
        this.stage.remove(this.plane);

        const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

        const thisFirstPoint = new THREE.Vector3(fPoint.x, height, fPoint.y);
        const thisSecondPoint = new THREE.Vector3(sPoint.x, height, sPoint.y);

        const parentTier = this.stage.getCompoundFloor().children.find(tier => tier.userData.customId === currentTier.userData.parentCustomId);
        const parentFirstPointIndex = parentTier.userData.points.findIndex(point => point.childCustomId === currentTier.userData.customId);
        const parentFPoint = parentTier.userData.points[parentFirstPointIndex];
        const parentFirstPoint = new THREE.Vector3(parentFPoint.x, height, parentFPoint.y);
        const parentSecondPointIndex = parentFirstPointIndex + 1 === parentTier.userData.points.length ? 0 : parentFirstPointIndex + 1;
        const parentSPoint = parentTier.userData.points[parentSecondPointIndex];
        const parentSecondPoint = new THREE.Vector3(parentSPoint.x, height, parentSPoint.y);

        const A = new THREE.Vector3(thisFirstPoint.x, 0, thisFirstPoint.z);
        const B = new THREE.Vector3(thisSecondPoint.x, 0, thisSecondPoint.z);
        const C = new THREE.Vector3(parentFirstPoint.x, 0, parentFirstPoint.z);
        const D = new THREE.Vector3(parentSecondPoint.x, 0, parentSecondPoint.z);

        const AB = new THREE.Vector3(B.x - A.x, 0, B.z - A.z);
        const CD = new THREE.Vector3(D.x - C.x, 0, D.z - C.z);
        const DB = new THREE.Vector3(B.x - D.x, 0, B.z - D.z);
        const DC = new THREE.Vector3(C.x - D.x, 0, C.z - D.z);
        const CA = new THREE.Vector3(A.x - C.x, 0, A.z - C.z);
        const DA = new THREE.Vector3(A.x - D.x, 0, A.z - D.z);
        const CB = new THREE.Vector3(B.x - C.x, 0, B.z - C.z);

        const projectionLength = (DB.x * DC.x + DB.z * DC.z) / CD.length();
        const projectionLength2 = (CD.x * CA.x + CD.z * CA.z) / CD.length();
        const minLength = Math.min(projectionLength, projectionLength2, AB.length(), CD.length());

        // first point и secondPoint надо взять не всегда одни по эджу,
        // а близжайшие друг другу с двух эджей

        const projectParentSPOnThisFP = (DA.x * DC.x + DA.z * DC.z) / CD.length();
        if (projectParentSPOnThisFP < 0) {
          this.nearestRightPoint = parentSecondPoint;
          const vect = new THREE.Vector3(AB.z, 0, -AB.x);
          const norm = vect.clone().normalize().negate();
          const offsetToParent = this.constants.tierTypeSettingsMap[fPoint.superstructureType].distanceToTier;
          norm.setLength(offsetToParent);
          this.nearestRightPoint.add(norm);
        }
        else {
          this.nearestRightPoint = thisFirstPoint;
        }
        // this.nearestRightPoint = projectParentSPOnThisFP < 0 ? parentSecondPoint : thisFirstPoint;

        const projectParentFPOnThisSP = (CB.x * CD.x + CB.z * CD.z) / CD.length();
        if (projectParentFPOnThisSP < 0) {
          this.nearestLeftpoint = parentFirstPoint;
          const vect = new THREE.Vector3(AB.z, 0, -AB.x);
          const norm = vect.clone().normalize().negate();
          const offsetToParent = this.constants.tierTypeSettingsMap[fPoint.superstructureType].distanceToTier;
          norm.setLength(offsetToParent);
          this.nearestLeftpoint.add(norm);
        }
        else {
          this.nearestLeftpoint = thisSecondPoint;
        }

        // эти точки сейчас могут быть на разных плоскостях, нужно чтобы они всегда были в плоскости чайлд эджа

        this.edgesCommonSegmentLength = minLength;

        const edgeVector1 = new THREE.Vector3(
          this.nearestLeftpoint.x - this.nearestRightPoint.x,
          0,
          this.nearestLeftpoint.z - this.nearestRightPoint.z
        );
        const edgeVector2 = new THREE.Vector3(
          this.nearestLeftpoint.x - this.nearestRightPoint.x,
          0,
          this.nearestLeftpoint.z - this.nearestRightPoint.z
        );

        const edgeVector1Or = new THREE.Vector3(
          this.nearestLeftpoint.x - this.nearestRightPoint.x,
          0,
          this.nearestLeftpoint.z - this.nearestRightPoint.z
        );
        const edgeVector2Or = new THREE.Vector3(
          this.nearestLeftpoint.x - this.nearestRightPoint.x,
          0,
          this.nearestLeftpoint.z - this.nearestRightPoint.z
        );

        edgeVector2.negate();
        edgeVector2Or.negate();

        edgeVector1.setLength(child.children[0].scale.x * this.constants.inermediateStepSize.width / 2);
        edgeVector2.setLength(child.children[0].scale.x * this.constants.inermediateStepSize.width / 2);

        const centerPOr = new THREE.Vector3(
          child.children[0].getWorldPosition(new THREE.Vector3()).x,
          child.children[0].getWorldPosition(new THREE.Vector3()).y,
          child.children[0].getWorldPosition(new THREE.Vector3()).z
        );

        this.originalRight = new THREE.Vector3(centerPOr.x, centerPOr.y, centerPOr.z);
        this.originalRight.add(edgeVector1Or);
        this.originalLeft = new THREE.Vector3(centerPOr.x, centerPOr.y, centerPOr.z);
        this.originalLeft.add(edgeVector2Or);

        const centerP = new THREE.Vector3(child.children[0].position.x, child.children[0].position.y, child.children[0].position.z);

        const rightSprite = new AutoScaleSprite(50, 50, spriteMaterial);
        rightSprite.position.set(centerP.x, centerP.y, centerP.z);
        rightSprite.position.add(edgeVector2);
        this.widthSprites.push(rightSprite);
        rightSprite.name = 'Right sprite';
        rightSprite.userData.tier = currentTier;
        rightSprite.userData.stair = child;


        const leftSprite = new AutoScaleSprite(50, 50, spriteMaterial);
        leftSprite.position.set(centerP.x, centerP.y, centerP.z);
        leftSprite.position.add(edgeVector1);
        this.widthSprites.push(leftSprite);
        leftSprite.name = 'Left sprite';
        leftSprite.userData.tier = currentTier;
        leftSprite.userData.stair = child;

        const fp = new THREE.Vector3(thisSecondPoint.x, 0, thisSecondPoint.z);
        const sp = new THREE.Vector3(thisFirstPoint.x, 0, thisFirstPoint.z);
        const fpToScrn = this.sceneUtils.worldToScreen(fp);
        const spToScrn = this.sceneUtils.worldToScreen(sp);
        const firstPointToSecondPointvector = new THREE.Vector3(spToScrn.x - fpToScrn.x, 0, spToScrn.y - fpToScrn.y);
        const angle = -Math.atan2(firstPointToSecondPointvector.z, firstPointToSecondPointvector.x);
        leftSprite.material.rotation = angle;
        leftSprite.material.needsUpdate = true;
        rightSprite.material.rotation = angle;
        rightSprite.material.needsUpdate = true;

        this.stage.add(leftSprite);
        this.stage.add(rightSprite);

        this.plane = new THREE.Mesh(new THREE.PlaneGeometry(5000, 5000, 8, 8),
          new THREE.MeshBasicMaterial({
            color: 0x248f24, alphaTest: 1, side: THREE.DoubleSide, visible: false
          }));
        this.plane.position.set(leftSprite.position.x, leftSprite.position.y, leftSprite.position.z);
        this.plane.rotation.set(Math.PI / 2, 0, child.children[0].rotation.z);
        this.stage.add(this.plane);
      }
    }

    // for (let i = 0; i < tier.children.length; i++) {
    //   const child = tier.children[i];
    //   if (tier.userData.edge && child.name == "tierSteps") {

    //     this.edgeLength = tier.userData.edge.length;

    //     var spriteMap = this.loader.load('../../assets/images/sprites/size_grip.png');
    //     this.stage.remove(this.plane);

    //     var spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

    //     let firstPoint = new THREE.Vector3(tier.userData.edge.firstPoint.x, height, tier.userData.edge.firstPoint.y);
    //     let secondPoint = new THREE.Vector3(tier.userData.edge.secondPoint.x, height, tier.userData.edge.secondPoint.y);

    //     let edgeVector1 = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);
    //     let edgeVector2 = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);

    //     let edgeVector1Or = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);
    //     let edgeVector2Or = new THREE.Vector3(secondPoint.x - firstPoint.x, 0, secondPoint.z - firstPoint.z);

    //     edgeVector2.negate();
    //     edgeVector2Or.negate();

    //     edgeVector1.setLength(child.children[0].scale.x * this.constants.inermediateStepSize.width / 2);
    //     edgeVector2.setLength(child.children[0].scale.x * this.constants.inermediateStepSize.width / 2);

    //     let centerPOr = new THREE.Vector3(child.children[0].getWorldPosition(new THREE.Vector3()).x, child.children[0].getWorldPosition(new THREE.Vector3()).y, child.children[0].getWorldPosition(new THREE.Vector3()).z);

    //     this.originalRight = new THREE.Vector3(centerPOr.x, centerPOr.y, centerPOr.z);
    //     this.originalRight.add(edgeVector1Or);
    //     this.originalLeft = new THREE.Vector3(centerPOr.x, centerPOr.y, centerPOr.z);
    //     this.originalLeft.add(edgeVector2Or);

    //     let centerP = new THREE.Vector3(child.children[0].position.x, child.children[0].position.y, child.children[0].position.z);

    //     var rightSprite = new THREE.Sprite(spriteMaterial);
    //     rightSprite.scale.set(50, 50, 1);
    //     rightSprite.position.set(centerP.x, centerP.y, centerP.z);
    //     rightSprite.position.add(edgeVector1);
    //     this.widthSprites.push(rightSprite);
    //     rightSprite.name = "Right sprite";
    //     rightSprite.userData.tier = tier;
    //     rightSprite.userData.stair = child;
    //     this.stage.add(rightSprite);

    //     var leftSprite = new THREE.Sprite(spriteMaterial);
    //     leftSprite.scale.set(50, 50, 1);
    //     leftSprite.position.set(centerP.x, centerP.y, centerP.z);
    //     leftSprite.position.add(edgeVector2);
    //     this.widthSprites.push(leftSprite);
    //     leftSprite.name = "Left sprite";
    //     leftSprite.userData.tier = tier;
    //     leftSprite.userData.stair = child;
    //     this.stage.add(leftSprite);

    //     this.plane = new THREE.Mesh(new THREE.PlaneGeometry(5000, 5000, 8, 8),
    //       new THREE.MeshBasicMaterial({
    //         color: 0x248f24, alphaTest: 1, side: THREE.DoubleSide, visible: false
    //       }));
    //     this.plane.position.set(leftSprite.position.x, leftSprite.position.y, leftSprite.position.z);
    //     this.plane.rotation.set(Math.PI / 2, 0, child.children[0].rotation.z);
    //     this.stage.add(this.plane);
    //   }
    // }
  }

  removeSprites() {
    this.stage.removeMany(this.widthSprites);
    this.widthSprites = [];
    this.stage.remove(this.plane);
  }

  mouseDown(e: MouseEvent) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    let intersectionPos: any = null;

    const intersection = this.raycaster.intersectObjects(this.widthSprites);
    if (intersection.length) {
      if (this.appSettingsService.is2D) {
        this.moveCameraService.disable();
      }
      this.currentSprite = intersection[0].object;
      const intersectionPlane = this.raycaster.intersectObjects([this.plane]);
      intersectionPos = intersectionPlane[0].point;
      this.oldPosition = intersectionPos;

      const {tier, stair} = this.currentSprite.userData;
      const tierPoints =  tier.userData.points;
      const lastPoint = tierPoints[tierPoints.length - 1];
      const transformations = stair.children.map(child => ({
        position: child.position.clone(),
        scale: child.scale.clone()
      }));
      this.changeTierStepSizeAction = new Actions.TierStepSizeChangeAction(
        transformations,
        {width: lastPoint.width, distance: lastPoint.distance},
        tier.userData.customId
      );
    } else {
      this.currentSprite = null;
      this.removeSprites();
    }
  }

  mouseMove(e: MouseEvent) {
    if (this.currentSprite) {
      // this.orbit.disable();
      e.stopPropagation();
      const selectedTier = this.currentSprite.userData.tier;
      const stair = this.currentSprite.userData.stair;

      const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
      this.raycaster.ray.origin.copy(p.ray.origin);
      this.raycaster.ray.direction.copy(p.ray.direction);

      const intersectionPlane = this.raycaster.intersectObjects([this.plane]);
      const intersectionPos = intersectionPlane[0].point;
      this.newPosition = intersectionPos;

      const move = new THREE.Vector3(
        this.newPosition.x - this.oldPosition.x,
        this.newPosition.y - this.oldPosition.y,
        this.newPosition.z - this.oldPosition.z
      );
      const direction = new THREE.Vector3(
        this.nearestLeftpoint.x - this.nearestRightPoint.x,
        0,
        this.nearestLeftpoint.z - this.nearestRightPoint.z
      );
      const shift = move.projectOnVector(direction);
      shift.setLength(shift.length() / 2);

      let newWidth: number, newDistance: number;
      for (let i = 0; i < stair.children.length; i++) {
        switch (this.currentSprite.name) {
          case 'Right sprite': {
            if (shift.x * direction.x + shift.z * direction.z > 0) {
              newWidth = stair.children[i].scale.x * this.constants.inermediateStepSize.width - shift.length() * 2;
              newDistance = selectedTier.userData.points[selectedTier.userData.points.length - 1].distance + shift.length();
            } else {
              newWidth = stair.children[i].scale.x * this.constants.inermediateStepSize.width + shift.length() * 2;
              newDistance = selectedTier.userData.points[selectedTier.userData.points.length - 1].distance - shift.length();
            }
          }
            break;
          case 'Left sprite': {
            if (shift.x * direction.x + shift.z * direction.z > 0) {
              newWidth = stair.children[i].scale.x * this.constants.inermediateStepSize.width + shift.length() * 2;
              newDistance = selectedTier.userData.points[selectedTier.userData.points.length - 1].distance + shift.length();
            } else {
              newWidth = stair.children[i].scale.x * this.constants.inermediateStepSize.width - shift.length() * 2;
              newDistance = selectedTier.userData.points[selectedTier.userData.points.length - 1].distance - shift.length();
            }
          }
            break;
        }
        if (newWidth / this.constants.inermediateStepSize.width < 1 ||
          this.edgesCommonSegmentLength - newDistance -this.minimalSpaceForStairsOnSIde < newWidth / 2 ||
          newDistance -this.minimalSpaceForStairsOnSIde < newWidth / 2) {
          return;
        }

        stair.children[i].position.add(shift);
        stair.children[i].scale.x = newWidth / this.constants.inermediateStepSize.width;
      }
      this.currentSprite.position.add(shift);
      this.currentSprite.position.add(shift);
      selectedTier.userData.points[selectedTier.userData.points.length - 1].width = newWidth;
      selectedTier.userData.points[selectedTier.userData.points.length - 1].distance = newDistance;

      stair.userData.config.width = newWidth;

      this.oldPosition = this.newPosition;
    }
  }

  mouseUp() {
    if (this.currentSprite) {
      let stair = this.currentSprite.userData.stair
      const data = this.checkMinDistanceToEdgePoints();

      if (data.needStepRebuild) {
        let delta = data.delta;
        const newWidth = data.newWidth;
        stair.userData.config.width = newWidth;
        const newDistance = data.newDistance;
        let selectedTier = this.currentSprite.userData.tier;
        const shift = delta;
        this.currentSprite.position.add(shift)
        shift.setLength(shift.length() / 2);
        for (let i = 0; i < stair.children.length; i++) {
          stair.children[i].position.add(shift);
          stair.children[i].scale.x = newWidth / this.constants.inermediateStepSize.width;
        }
        if (newWidth && newDistance) {
          selectedTier.userData.points[selectedTier.userData.points.length - 1].width = newWidth;
          selectedTier.userData.points[selectedTier.userData.points.length - 1].distance = newDistance;
        }
      }
      this.currentSprite = null;
      this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
      this.eventLogSrvc.dispatch(this.changeTierStepSizeAction);
    }
  }

  disable() {
    this.removeSprites();
    this.selectTierSubscription && this.selectTierSubscription.unsubscribe();
    super.disable();
  }

  enable() {
    super.enable();
    if (!this.selectTierSubscription || this.selectTierSubscription.isStopped) {
      this.selectTierSubscription = this.select3dService.selectedTierSubject.subscribe(tier => {
        if (!tier.userData.mainFloor) {
          this.removeSprites();
          this.drawSprites();
        }
      });
    }
  }

  checkMinDistanceToEdgePoints() {
    let sprite = this.currentSprite;
    let newWidth, newDistance;
    const distance = sprite.userData.tier.userData.points[3].distance;
    const width = sprite.userData.tier.userData.points[3].width;
    const lenth = this.edgesCommonSegmentLength;
    let delta;
    let needStepRebuild = false;

    switch (this.currentSprite.name) {
      case 'Right sprite': {
        const distanceToCorner = distance - width / 2;
        if (distanceToCorner < 15) {
          const direction = new THREE.Vector3(
          this.nearestLeftpoint.x - this.nearestRightPoint.x,
          0,
          this.nearestLeftpoint.z - this.nearestRightPoint.z
          );
          direction.setLength(-distanceToCorner);
          delta = direction;
          newWidth = width + distanceToCorner;
          newDistance = distance - distanceToCorner / 2;
          needStepRebuild = true;
        }
        else if (distanceToCorner < 30) {
          const offset = 30 - distanceToCorner;
          const direction = new THREE.Vector3(
            this.nearestLeftpoint.x - this.nearestRightPoint.x,
            0,
            this.nearestLeftpoint.z - this.nearestRightPoint.z
            );
            direction.setLength(offset);
            delta = direction;
          newWidth = width - offset;
          newDistance = distance + offset / 2;
          needStepRebuild = true;
        }
        break
      }
      case 'Left sprite': {
        const distanceToCorner = lenth - (distance + width / 2);
        if (distanceToCorner < 15) {
          const direction = new THREE.Vector3(
            this.nearestLeftpoint.x - this.nearestRightPoint.x,
            0,
            this.nearestLeftpoint.z - this.nearestRightPoint.z
            );
            direction.setLength(distanceToCorner);
            delta = direction;
          newWidth = width + distanceToCorner;
          newDistance = distance + distanceToCorner / 2;
          needStepRebuild = true;
        }
        else if (distanceToCorner < 30) {
          const offset = 30 - distanceToCorner;
          const direction = new THREE.Vector3(
            this.nearestLeftpoint.x - this.nearestRightPoint.x,
            0,
            this.nearestLeftpoint.z - this.nearestRightPoint.z
            );
            direction.setLength(-offset);
            delta = direction;
          newWidth = width - offset;
          newDistance = distance - offset / 2;
          needStepRebuild = true;
        }
        break
      }
    }
    return {
      delta: delta,
      newWidth: newWidth,
      newDistance: newDistance,
      needStepRebuild: needStepRebuild
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/tier-step-width.service.ts